module.exports = __webpack_public_path__ + "img/1_001.ef6b00a0.jpg";